export class AudioMetadata {
  public title: string;
  public artist: string;
  public date: Date | null;
  public language: string;
  public contentType: string;
  public location: string;
  public copyright: string;
  public description: string;
  public altText: string;
  public lyric: string;

  constructor(data: any = {}) {
    this.title = data?.title ?? '';
    this.artist = data?.artist ?? '';
    this.date = data?.date ? new Date(data?.date) : null;
    this.language = data?.language ?? '';
    this.contentType = data?.contentType ?? '';
    this.location = data?.location ?? '';
    this.copyright = data?.copyright ?? '';
    this.description = data?.description ?? '';
    this.altText = data?.altText ?? '';
    this.lyric = data?.lyric ?? '';
  }

  public static createFromApi(data: any = {}): AudioMetadata {
    return new AudioMetadata(data);
  }

  public processForApi(): Record<string, any> {
    return {
      ...this,
      date: this.date instanceof Date ? this.date.toJSON() : null,
    };
  }
}
